(() => {
  const root = document.querySelector('#mm-cart');
  if (!root) return;
  let cart;
  const halloweenCode = 'HALLOWEEN15';
  const halloweenKey = 'mm_halloween_REUj95_2026';
  const halloweenEnd = Date.parse('2026-11-01T00:00:00+01:00');
  let halloweenRegistered = false;
  let halloweenRequest;
  const cartUrl = path => (window.Shopify?.routes?.root || '/') + path;
  function halloweenEligible() {
    if (Date.now() >= halloweenEnd) return false;
    try { return halloweenRegistered || localStorage.getItem(halloweenKey) === 'registered'; }
    catch (_) { return halloweenRegistered; }
  }
  async function applyHalloween(currentCart) {
    if (!halloweenEligible() || !currentCart.item_count) return currentCart;
    const codes = (currentCart.discount_codes || []).map(entry => entry.code).filter(Boolean);
    if (codes.some(code => code.toUpperCase() === halloweenCode) || halloweenSaving(currentCart)) return currentCart;
    if (!halloweenRequest) {
      halloweenRequest = fetch(cartUrl('cart/update.js'), {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({discount: [...new Set([...codes, halloweenCode])].join(',')})
      }).then(response => {
        if (!response.ok) throw new Error('Halloween discount could not be applied');
        return response.json();
      }).finally(() => { halloweenRequest = undefined; });
    }
    try { return await halloweenRequest; }
    catch (_) { return currentCart; }
  }
  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail;
    if (detail?.formId !== 'REUj95' || detail.type !== 'submit' || Date.now() >= halloweenEnd) return;
    halloweenRegistered = true;
    try { localStorage.setItem(halloweenKey, 'registered'); } catch (_) {}
    refresh();
  });
    const format = cents => '\u20AC' + (cents / 100).toLocaleString(document.documentElement.lang || 'es-ES', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  const safe = value => String(value || '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const open = () => { root.setAttribute('aria-hidden', 'false'); root.querySelector('.mm-cart__body').scrollTop = 0; document.documentElement.style.overflow = 'hidden'; refresh(); };
  const close = () => { root.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; };
  async function refresh() {
    const currentCart = await fetch(cartUrl('cart.js')).then(response => response.json());
    cart = await applyHalloween(currentCart);
    render();
    loadUpsell();
  }
  function render() {
    const empty = root.querySelector('[data-mm-cart-empty]');
    const filled = root.querySelector('[data-mm-cart-filled]');
    const footer = root.querySelector('[data-mm-cart-footer]');
    root.querySelector('[data-mm-cart-count]').textContent = cart.item_count;
    empty.hidden = Boolean(cart.item_count);
    filled.hidden = !cart.item_count;
    footer.hidden = !cart.item_count;
    if (!cart.item_count) return;
    root.querySelector('[data-mm-cart-items]').innerHTML = cart.items.map(item => {
      const regular = item.original_price || item.final_price;
      const saving = Math.max(0, regular - item.final_price);
      return '<article class="mm-cart__line" data-mm-cart-line="' + item.key + '"><img src="' + item.image + '" alt="' + safe(item.product_title) + '"><div class="mm-cart__line-content"><button class="mm-cart__remove" type="button" aria-label="Eliminar" data-mm-cart-remove="' + item.key + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14M9 7V5h6v2M8 10v8M12 10v8M16 10v8M6 7l1 14h10l1-14"></path></svg></button><h3>' + safe(item.product_title) + '</h3><p class="mm-cart__variant">' + safe(item.variant_title) + '</p><div class="mm-cart__price-row">' + (saving ? '<s>' + format(regular) + '</s>' : '') + '<strong>' + format(item.final_price) + '</strong>' + (saving ? '<span>(Ahorras ' + format(saving) + ')</span>' : '') + '</div><div class="mm-cart__qty"><button type="button" data-mm-cart-qty="' + item.key + '" data-mm-cart-delta="-1">&minus;</button><span>' + item.quantity + '</span><button type="button" data-mm-cart-qty="' + item.key + '" data-mm-cart-delta="1">+</button></div></div></article>';
    }).join('');
    root.querySelector('[data-mm-cart-subtotal]').textContent = format(cart.total_price);
    root.querySelector('[data-mm-cart-checkout-total]').textContent = format(cart.total_price);
    renderHalloweenSummary(cart);
  }
    function halloweenSaving(currentCart) {
    const matches = application => {
      if (!application) return false;
      const title = String(application.title || '').trim();
      return title.toUpperCase() === 'HALLOWEEN15' ||
        (/\bHALLOWEEN\b/i.test(title) && application.value_type === 'percentage' && Number(application.value) === 15);
    };
    let amount = (currentCart.cart_level_discount_applications || []).reduce((total, application) =>
      total + (matches(application) ? Number(application.total_allocated_amount) || 0 : 0), 0);
    for (const item of currentCart.items || []) {
      amount += (item.line_level_discount_allocations || []).reduce((total, allocation) =>
        total + (matches(allocation.discount_application) ? Number(allocation.amount) || 0 : 0), 0);
    }
    const legacyAmount = (currentCart.items || []).reduce((total, item) =>
      total + (item.discounts || []).reduce((subtotal, discount) =>
        subtotal + (matches(discount) ? Number(discount.amount) || 0 : 0), 0), 0);
    amount = Math.max(amount, legacyAmount);
    return Number.isSafeInteger(amount) && amount > 0 && amount <= Number(currentCart.original_total_price) ? amount : 0;
  }
  function renderHalloweenSummary(currentCart) {
    const subtotal = root.querySelector('.mm-cart__subtotal');
    const price = root.querySelector('[data-mm-cart-subtotal]');
    if (!subtotal || !price) return;
    let offer = root.querySelector('[data-mm-cart-halloween]');
    let before = root.querySelector('[data-mm-cart-before-halloween]');
    if (!offer) {
      const style = document.createElement('style');
      style.textContent = '#mm-cart .mm-cart__halloween{display:flex;align-items:center;gap:8px;margin-top:12px;padding:11px 12px;border-radius:16px;background:var(--mm-cart-soft);color:var(--mm-cart-green);font-size:12px;line-height:1.3}#mm-cart .mm-cart__halloween[hidden],#mm-cart [data-mm-cart-before-halloween][hidden]{display:none!important}#mm-cart .mm-cart__halloween svg{flex:0 0 17px;width:17px;height:17px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}#mm-cart .mm-cart__halloween-label{font-weight:600}#mm-cart .mm-cart__halloween-amount{margin-left:auto;white-space:nowrap;font-weight:400}#mm-cart .mm-cart__halloween-prices{display:flex;flex-direction:column;align-items:flex-end;gap:5px}#mm-cart [data-mm-cart-before-halloween]{font-size:16px;font-weight:400;color:#747873;text-decoration-thickness:1px;white-space:nowrap}#mm-cart .mm-cart__subtotal:has([data-mm-cart-before-halloween]:not([hidden])){align-items:flex-start}';
      style.textContent += '#mm-cart .mm-cart__price-row>s,#mm-cart .mm-cart__price-row>span,#mm-cart .mm-cart__halloween-amount{display:none!important}';
      root.appendChild(style);
      offer = document.createElement('div');
      offer.className = 'mm-cart__halloween';
      offer.dataset.mmCartHalloween = '';
      offer.hidden = true;
      offer.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z"></path><circle cx="7.5" cy="7.5" r="1"></circle></svg><span class="mm-cart__halloween-label">Oferta Halloween −15%</span><span class="mm-cart__halloween-amount" data-mm-cart-halloween-amount></span>';
      subtotal.before(offer);
      const prices = document.createElement('span');
      prices.className = 'mm-cart__halloween-prices';
      before = document.createElement('s');
      before.dataset.mmCartBeforeHalloween = '';
      before.hidden = true;
      price.before(prices);
      prices.append(before, price);
      subtotal.querySelector(':scope > span').dataset.mmCartTotalLabel = '';
    }
    const saving = halloweenSaving(currentCart);
    const quantityTitles = new Set(['2 productos · −10%', '3 productos · −15%', '4 o más productos · −20%']);
    const allocations = [
      ...(currentCart.cart_level_discount_applications || []).map(application => ({title: application.title, amount: application.total_allocated_amount})),
      ...(currentCart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => ({title: allocation.discount_application?.title, amount: allocation.amount})))
    ].filter(allocation => quantityTitles.has(allocation.title));
    const quantityAmount = allocations.reduce((total, allocation) => total + (Number(allocation.amount) || 0), 0);
    const quantitySaving = Number.isSafeInteger(quantityAmount) && quantityAmount > 0 && quantityAmount <= Number(currentCart.original_total_price) ? quantityAmount : 0;
    let quantityOffer = root.querySelector('[data-mm-cart-quantity-offer]');
    if (!quantityOffer) {
      quantityOffer = offer.cloneNode(true);
      quantityOffer.removeAttribute('data-mm-cart-halloween');
      quantityOffer.dataset.mmCartQuantityOffer = '';
      quantityOffer.querySelector('[data-mm-cart-halloween-amount]').removeAttribute('data-mm-cart-halloween-amount');
      offer.before(quantityOffer);
    }
    const halloweenActive = Boolean(currentCart.item_count && saving);
    const quantityActive = Boolean(currentCart.item_count && quantitySaving);
    const active = halloweenActive || quantityActive;
    offer.hidden = !halloweenActive;
    quantityOffer.hidden = !quantityActive;
    before.hidden = !active;
    root.querySelector('[data-mm-cart-total-label]').textContent = active ? 'Total' : 'Subtotal';
    if (!active) return;
    offer.querySelector('[data-mm-cart-halloween-amount]').textContent = '−' + format(saving);
    quantityOffer.querySelector('.mm-cart__halloween-label').textContent = [...new Set(allocations.map(allocation => allocation.title))].join(' / ');
    quantityOffer.querySelector('.mm-cart__halloween-amount').textContent = '−' + format(quantitySaving);
    before.textContent = format(currentCart.total_price + saving + quantitySaving);
  }
async function change(key, quantity) {
    await fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: key, quantity})});
    refresh();
  }
  async function loadUpsell() {
    const area = root.querySelector('[data-mm-cart-upsell]');
    const slot = root.querySelector('[data-mm-cart-upsell-card]');
    if (!cart || !cart.items.length) return;
    try {
      let result = await fetch('/recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=4&intent=complementary').then(response => response.json());
      let product = result.products.find(item => !cart.items.some(line => line.product_id === item.id));
      if (!product) {
        result = await fetch('/products.json?limit=12').then(response => response.json());
        product = result.products.find(item => !cart.items.some(line => line.product_id === item.id));
      }
      if (!product) return;
      const variant = product.variants.find(item => item.available) || product.variants[0];
      const image = product.featured_image?.src || product.featured_image || product.images?.[0]?.src || product.images?.[0] || cart.items[0].image;
      const options = product.variants.filter(item => item.available).map(item => '<option value="' + item.id + '">' + safe(item.title) + '</option>').join('');
      const compare = variant.compare_at_price > variant.price ? '<s>' + format(variant.compare_at_price * 100) + '</s>' : '';
      slot.innerHTML = '<div class="mm-cart__upsell-card"><img src="' + image + '" alt="' + safe(product.title) + '"><div><h4>' + safe(product.title) + '</h4><p>' + compare + '<strong>' + format(variant.price * 100) + '</strong></p><div class="mm-cart__upsell-actions"><select aria-label="Elegir variante" data-mm-cart-upsell-select>' + options + '</select><button type="button" data-mm-cart-add="' + variant.id + '">A\u00F1adir</button></div></div></div>';
      area.hidden = false;
    } catch (_) { area.hidden = true; }
  }
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-mm-cart-close]')) return close();
    const link = event.target.closest('a[href*="/cart"]');
    if (link && !link.closest('#mm-cart')) { event.preventDefault(); return open(); }
    const remove = event.target.closest('[data-mm-cart-remove]');
    if (remove) return change(remove.dataset.mmCartRemove, 0);
    const quantity = event.target.closest('[data-mm-cart-qty]');
    if (quantity) { const item = cart.items.find(line => line.key === quantity.dataset.mmCartQty); if (item) return change(item.key, Math.max(0, item.quantity + Number(quantity.dataset.mmCartDelta))); }
    const add = event.target.closest('[data-mm-cart-add]');
    if (add) { const id = Number(add.closest('.mm-cart__upsell-card').querySelector('[data-mm-cart-upsell-select]').value); await fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id, quantity: 1}]})}); return refresh(); }
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    fetch(cartUrl('cart/add.js'), {method: 'POST', body: new FormData(event.target)}).then(open);
  }, {capture: true});
  document.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
})();
